<ng-container *ngIf="marketGroups.length">
    <ms-market-groups [groups]="marketGroups" (selectedTab)="onSelectedTab($event, true)"> </ms-market-groups>
    <ms-multi-builder-onboarding *ngIf="showOnboardingMessage"></ms-multi-builder-onboarding>
    <div class="cards-list" *ngIf="selectedTab">
        <div class="upcoming-events" *ngFor="let multiBuilderEvent of multiBuilderEvents">
            <div class="event-date" *ngIf="showDate(multiBuilderEvent)">
                {{ multiBuilderEvent.day }}
            </div>
            <div class="upcoming-cards">
                <ng-container *ngFor="let gridEvent of multiBuilderEvent.fixtures; trackBy: trackFixtures">
                    <ms-multi-builder-card
                        *ngIf="optionGroups[gridEvent.id]"
                        [gridEvent]="gridEvent"
                        [selectedTab]="selectedTab"
                        [optionNames]="optionNames"
                        [optionGroup]="optionGroups[gridEvent.id]"
                        [statistics]="statisticsMapping[gridEvent.id]">
                        <div class="live-timer" *ngIf="gridEvent.live">
                            <p class="live-icon">{{ sitecore.globalMessages.NavLive }}</p>
                            <ms-event-timer
                                class="card-event-date"
                                [live]="gridEvent.live"
                                [start]="gridEvent.startDate"
                                [scoreboard]="gridEvent.scoreboard">
                            </ms-event-timer>
                        </div>
                    </ms-multi-builder-card>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

<ms-multi-builder-combo-prevention-error></ms-multi-builder-combo-prevention-error>
